import React, { useEffect, useRef } from 'react'
import './RetroCursorTrail.css'

const COLORS = ['#ff00ff', '#00ffff', '#ffff00', '#00ff00', '#ff6600']
const MAX_DOTS = 18

const RetroCursorTrail = () => {
  const containerRef = useRef(null)
  const dotsRef = useRef([])
  const colorIndex = useRef(0)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return undefined

    const handleMouseMove = (event) => {
      const dot = document.createElement('span')
      dot.className = 'retro-cursor-dot'
      dot.style.left = `${event.clientX}px`
      dot.style.top = `${event.clientY}px`
      dot.style.color = COLORS[colorIndex.current % COLORS.length]
      dot.style.background = COLORS[colorIndex.current % COLORS.length]
      colorIndex.current += 1
      container.appendChild(dot)
      dotsRef.current.push(dot)

      if (dotsRef.current.length > MAX_DOTS) {
        const old = dotsRef.current.shift()
        old.remove()
      }

      requestAnimationFrame(() => {
        dot.style.opacity = '0'
        dot.style.transform = 'translate(-50%, -50%) scale(0.2)'
      })

      setTimeout(() => {
        dot.remove()
        dotsRef.current = dotsRef.current.filter((d) => d !== dot)
      }, 650)
    }

    window.addEventListener('mousemove', handleMouseMove)
    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      dotsRef.current.forEach((dot) => dot.remove())
      dotsRef.current = []
    }
  }, [])

  return (
    <div className="retro-cursor-trail" ref={containerRef} aria-hidden="true" />
  )
}

export default RetroCursorTrail
